import { z } from 'zod';

export const UserDetailsResponseSchema = z.array(
  z.object({
    id: z.number(),
    firstName: z.string(),
    lastName: z.string(),
  }),
);
